export const AuthMiddleWare = (navigate) => {
    const authToken = localStorage.getItem('AuthToken');
    if (authToken === null){
        navigate('/signin')
    }
}